// @file Entrypoint for request reset password page
import { captureException } from '@@/bits/error_tracker'
import { setupVueApp } from '@@/bits/vue'
import { useRequestResetPasswordStore } from '@@/pinia/request_reset_password_store'
import RequestResetPasswordApp from '@@/vuecomponents/RequestResetPasswordApp.vue'

setupVueApp({
  el: '#request_reset_password',
  rootComponent: RequestResetPasswordApp,
  usePinia: true,
  initializePiniaStore() {
    useRequestResetPasswordStore().initializeState()
  },
}).catch(captureException)
